define('imovelcliente-controller',[
    'directive/ng-flow/dist/ng-flow-standalone.min',
    'directive/flow.js/dist/flow.min',
    'directive/ng-flow/dist/ng-flow.min',
    'imovelcliente-resource',
    'imovel-resource',
    'angular-file-upload',
    'jquery-inputmask',
], function() {

    var app = angular.module('imovelcliente.controller', [
        'imovelcliente.resource',
        'imovel.resource',
        'ui.mask',
        'flow',
    ]);


    app.controller('ImovelclienteController', ['$scope', '$rootScope','Imovel', 'Imovelcliente','$selectUIService', 'vcRecaptchaService', function($scope, $rootScope, Imovel, Imovelcliente, $selectUIService, vcRecaptchaService) {
        $scope.estados = estados;
        $scope.paises = paises;
        $scope.showPaises = showPaises;
        $scope.showDocumentos = showDocumentos;
        $scope.documentos = documentos;
        $scope.tipoCadastro = tipoCadastro;
        $scope.termoConfig = termoConfig;
        $scope.imobiliariaCidade = imobiliariaCidade;
        $scope.showDocumentos = (showDocumentos && documentos.length > 0);
        $scope.selectedEstado = {};
        $scope.selectedPais = {};
        $scope.cidades = [];
        $scope.selectedCidade = null;
        $scope.selectedTipoCadastro = null;
        $scope.TipoNegocios = [
            {
                val: 'VENDA',
                name: 'Vender'
            },
            {
                val: 'VENDALOCACAO',
                name: 'Vender ou alugar'
            },
            {
                val: 'LOCACAO',
                name: 'Alugar'
            }
        ];

        $scope.booleanSimNao = [
            {
                val: false,
                name: 'Não'
            },
            {
                val: true,
                name: 'Sim'
            },
        ];

        $scope.steps = [1];

        $scope.imovel = null;
        $scope.formStep = 1;
        $scope.flowsList = []

        $scope.imovelUsuario = {
            imou_nome_cliente: null,
            imou_telefone_cliente: null,
            imou_email_cliente: null,
            imou_numero: null,
            imou_bairro: null,
            imou_endereco: null,
            imou_complemento: null,
            tic_codigo: null,
            cid_codigo: imobiliariaCidade.cid_codigo,
            est_codigo: imobiliariaCidade.est_codigo,
            pais_codigo: imobiliariaCidade.est_codigo ? 1 : null,
            imou_is_locacao: null,
            imou_is_venda: null,
            imou_preco_locacao: null,
            imou_preco_venda: null,
            imou_concordo: false,
            imou_matricula: null,
            imou_financiado: false,
            selectedTipoNegocio: 'VENDA',
            termo: {},
        };

        $scope.formatPhoneOnDemand = (phone) => {
            let digits = phone ? phone.replace(/[^0-9]/g, "").length : 0;
            let mask = digits <= 10 ? "(99) 9999-9999?9" : "(99) 9 9999-999?9";
            $(`#imou_telefone_cliente`).mask(mask);
        };

        $scope.verifyPhone = (phone, form) => {
            if (phone) {
                phone = phone.replace(/\D/g, "");
                var tam = phone.length;
                phone = tam > 11 ? phone.slice(phone.length - 11) : phone;
                form.imou_telefone_cliente.$setValidity('mask', false)
                if (tam == 10 || tam == 11) {
                    form.imou_telefone_cliente.$setValidity('mask', true)
                };
            }
        };

        $scope.formatDocumentOnDemand = (document) => {
            if (document) {
                let digits = document.replace(/[^0-9]/g, "").length;
                let mask = digits <= 12 ? "999.999.999-99?999" : "99.999.999/999?9-99";
                $(`#imou_cpfcnpj_cliente`).mask(mask);
            }
        };


        // Funções de validação do CPF/CNPJ foram retiradas do arquivo angular-input-masks.js.
        // Foram feitas múltiplas alterações para que as funções comportem tanto o CPF quanto o CNPJ.
        var verifyMod11Digit = (numbers) => {
            numbers = numbers.replace(/\D/g, "").split("");
            var modulus = numbers.length + 1;
            var multiplied = numbers.map(function (number, index) {
                return number * (modulus - index);
            });
            var mod = multiplied.reduce(function (buffer, number) {
                return buffer + number;
            }) % 11;
            return (mod % 11 < 2 ? 0 : 11 - mod % 11);
        };

        var verifyMod11 = (number) => {
            let isValid = false;
            if (number) {
                number = number.replace(/[^\d]/g, "");
                if (number.length !== 14 && number.length !== 11) {
                    return false;
                }
                let debug = (number.length == 14 ? 12 : 9);
                var numbers = number.substr(0, debug);
                numbers += verifyMod11Digit(numbers);
                numbers += verifyMod11Digit(numbers);
                isValid = (numbers.substr(-2) === number.substr(-2));
                return isValid;
            } else {
                return false;
            }
        };

        $scope.validateCPFCNPJ = (cpf, form) => {
            let isValid = verifyMod11(cpf);
            form.imou_cpfcnpj_cliente.$setValidity('mask', isValid);
        }

        $scope.currency = function(id){
            $(id).maskMoney();
        };

        $scope.gerarTermoImovelUsuario = () => {
            let operacao = $scope.imovelUsuario.selectedTipoNegocio;
            let payload = {
                pes_nome: $scope.imovelUsuario.imou_nome_cliente,
                pesf_telefone: $scope.imovelUsuario.imou_telefone_cliente ? $scope.imovelUsuario.imou_telefone_cliente.replace(/\D/g, "") : null,
                pesem_email: $scope.imovelUsuario.imou_email_cliente,
                cpfcnpj: $scope.imovelUsuario.imou_cpfcnpj_cliente ? $scope.imovelUsuario.imou_cpfcnpj_cliente.replace(/\D/g, "") : null,
                operacao: operacao,
            };

            Imovelcliente.gerarTermoImovelUsuario(payload).then(function (response) {
                $scope.imovelUsuario.termo.imout_termo = response.termo;
            });
        };

        $scope.responserecaptcha = null;

        $scope.totalFiles = 0;
        $scope.limiteDeUpload = 10;
        $scope.submitImageFlow =  function($flow) {
            $flow.opts.target = '/enviarimovel/imovelusuario/uploadImg/'+$scope.imovel.imou_codigo;
            $flow.upload();
        };

        $scope.submitDocumentFlow =  function($flow) {
            $flow.opts.target = '/enviarimovel/imovelusuario/uploadDoc/'+$scope.imovel.imou_codigo;
            $flow.upload();
        };

        $scope.validDocumentExtensions = [
            'pdf',
            'doc',
            'docx',
            'jpg',
            'jpeg',
            'xlsx',
            'png'
        ];

        $scope.validImageExtensions = [            
            'png',
            'gif',
            'jpg',
            'jpeg',
        ];

        $scope.maxDocuments = 3;
        $scope.maxImages = 10;

        $scope.validateDocumentFile = ($file, $event, $flow) => {
            if ($scope.validDocumentExtensions.includes($file.getExtension())) {
                if ($file.size < (10e+6)) { // Limite de 10 megas por arquivo "10.000.000 bytes"
                    return true;
                };
            };
            return false;
        }

        $scope.validateImageFile = function(file, event, flow){
            if ($scope.validImageExtensions.includes(file.getExtension())) {
                if (file.size < (3e+6)) { // Limite de 3 megas por arquivo "3.000.000 bytes"
                    return true;
                };
            };
            return false;
        };

        $scope.submitFileFlow = function ($flow, max, acoi_codigo) {
            if ($flow.files.length > max) {
                for(var i = $flow.files.length; i > max; i--){
                    $flow.files.pop(); // remove a sobra de arquivos
                };
            };
            $scope.appendFlow($flow, acoi_codigo)
        };

        $scope.uploadFlows = function () {
            var data = {
                imovelUsuario: $scope.imovelUsuario,
                responserecaptcha: $scope.responserecaptcha,
            };

            data.imovelUsuario.imou_is_venda = $scope.imovelUsuario.selectedTipoNegocio == 'VENDA' || $scope.imovelUsuario.selectedTipoNegocio == 'VENDALOCACAO' ? true : false;
            data.imovelUsuario.imou_is_locacao = $scope.imovelUsuario.selectedTipoNegocio == 'LOCACAO' || $scope.imovelUsuario.selectedTipoNegocio == 'VENDALOCACAO' ? true : false;

            Imovelcliente.create(data).then(function (response) {
                var objToEmail = {
                    termo: $scope.imovelUsuario.termo,
                    proprietario_nome: $scope.imovelUsuario.imou_nome_cliente,
                    proprietario_email: $scope.imovelUsuario.imou_email_cliente
                };
                Imovelcliente.enviarCopiaTermoEmail(objToEmail).then(result=>{
                    $scope.imovel = response.imovelusuario;
                    if ($scope.flowsList.length > 0) {
                    $scope.flowsList.forEach(item=>{
                        if (item.acoi_codigo == 0) {
                            item.flow.opts.target = '/enviarimovel/imovelusuario/uploadImg/' + $scope.imovel.imou_codigo;
                            $scope.uploadImg(item.flow)
                        } else {
                            item.flow.opts.query = {
                                acoi_codigo: item.acoi_codigo
                            }
                            item.flow.opts.target = '/enviarimovel/imovelusuario/uploadDoc/' + $scope.imovel.imou_codigo;
                            $scope.uploadDoc(item.flow)
                        };
                    })
                };
                $scope.nextStep();
            });
            });
        };

        $scope.goHome = ()=>{
            window.location.href = '/';
        };

        $scope.reloadPage = ()=>{
            window.location.reload()
        };

        $scope.previousStep = () => {
            if ($scope.formStep == 4 && !$scope.showDocumentos) { // Caso seja foto e a config. de documentos esteja como false, ir direto ao termo.
                $scope.formStep = $scope.formStep - 1; // Pular tela de documentos
            };
            $scope.formStep = $scope.formStep - 1;
            $scope.validForm = true;
        };

        $scope.validateForm = (form) => {
            $scope.resolveCaptcha = !$scope.responserecaptcha ? false : true;
            if (form.$valid) {
                $scope.validForm = true;
            } else {
                $scope.validForm = false;
                angular.forEach(form.$error.required, function (value, key) {
                    form.$error.required[key].$pristine = false;
                });
            };
        };
        $scope.nextStep = (form) => {
            if (form) {
                $scope.validateForm(form);
                if ($scope.validForm) {
                    $scope.formStep = $scope.formStep + 1;
                    $scope.steps.push($scope.formStep);
                    $scope.validForm = false;
                };
            } else {
                if ($scope.formStep == 2 && !$scope.showDocumentos) { // Caso seja foto e a config. de documentos esteja como false, ir direto ao termo.
                    $scope.formStep = $scope.formStep + 1; // Pular tela de documentos
                    $scope.steps.push($scope.formStep);
                };
                $scope.formStep = $scope.formStep + 1;
                $scope.steps.push($scope.formStep);
            }
        }

        $scope.changeStep = (step, form) => {
            if (typeof step == 'string') {
                if (step == 'next') {
                    $scope.nextStep(form);
                } else if (step = 'prev') {
                    $scope.previousStep();
                }
            } else if (typeof step == 'number') {
                if (form) {
                    $scope.validateForm(form);
                    if ($scope.validForm) {
                        if ($scope.steps.includes(step)) {
                            $scope.formStep = step;
                        }
                    }
                } else {
                    if ($scope.steps.includes(step)) {
                        $scope.formStep = step;
                    }
                }
            };
        };

        $scope.appendFlow = (flow, acoi_codigo) => {
            let idxOnList = $scope.flowsList.findIndex(f => f.nome == acoi_codigo)
            if (idxOnList >= 0) {
                $scope.flowsList[idxOnList].flow = flow;
            }else{
                $scope.flowsList.push({
                    acoi_codigo: acoi_codigo,
                    flow: flow
                });
            }

        }

        $scope.addUpload = function(item){
            $scope.uploadSlider = item;
        }

        $scope.docext = {
            'png': 'fa-file-image-o',
            'jpg': 'fa-file-image-o',
            'jpeg': 'fa-file-image-o',
            
            'xlsx': 'fa-file-excel-o',
            'docx': 'fa-file-word-o',
            'doc': 'fa-file-word-o',
            'pdf': 'fa-file-pdf-o',

            '_blank': 'fa-file-o'
        };

        $scope.getIcoExt = function (ext) {
            if (ext) {
                if (typeof $scope.docext[ext] != 'undefined') {
                    return $scope.docext[ext];
                } else {
                    return $scope.docext['_blank'];
                }
            }
        };

        $scope.uploadImg  = function($flow) {
            if($flow.files != null && $flow.files.length > 0){
                $flow.upload();
            }
        };

        $scope.sucessUploadImg =  function (file, $message, $flow ) {
            $scope.flowReset = $flow;
            var data = {
                imou_codigo: $scope.imovel.imou_codigo,
                file: {
                    name:file.file.name,
                    type:file.file.type,
                    identifier:file.uniqueIdentifier
                }
            };
            Imovelcliente.successUploadImgImovelusuario(data).then(function(result){
                $scope.totalFiles--;
            });
        };

        $scope.uploadDoc  = function($flow) {
            $("#ajaxbloq").remove();
            if($flow.files != null && $flow.files.length > 0){
                $("body").append($("#ajaxbloqSrc").html());
                setTimeout(function() {
                    $flow.upload();
                    $("#ajaxbloq").remove();
                    //
                }, 1000);
            }
        };

        $scope.sucessUploadDoc =  function (file, $message, $flow, acoi_codigo) {
            $scope.flowReset = $flow;
            var data = {
                imou_codigo: $scope.imovel.imou_codigo,
                acoi_codigo: acoi_codigo,
                file: {
                    name:file.file.name,
                    type:file.file.type,
                    identifier:file.uniqueIdentifier
                }
            };
            Imovelcliente.successUploadDocImovelusuario(data).then(function(result){
                $scope.totalFiles--;
            })
        };

        $scope.getCidadeByEstado = function (estado){
            if(estado != null){
                Imovelcliente.getCidadeByEstado(estado.est_codigo).then(function (response) {
                    $scope.cidades = response;
                }).catch(function (error) {
                    console.error(error);
                });
            }else{
                alert('Selecione o estado !');
            }
        };
        if (imobiliariaCidade && imobiliariaCidade.cid_codigo) $scope.getCidadeByEstado(imobiliariaCidade);
        
        $scope.tmp_cep = undefined;
        $scope.buscarEnderecoPorCEP = function (cep) {
            if (cep && cep != $scope.tmp_cep) {
                Imovelcliente.buscarEnderecoPorCEPSite({cep: cep}).then(result=>{
                    result = result.data;
                    $scope.imovelUsuario.est_codigo = result.Cidade.est_codigo;
                    $scope.imovelUsuario.imou_endereco = result.imo_endereco;
                    $scope.imovelUsuario.imou_bairro = result.imo_bairro;
                    $scope.imovelUsuario.pais_codigo = result.Cidade.Estado.pais_codigo;
                    $scope.getCidadeByEstado($scope.imovelUsuario);
                    $scope.imovelUsuario.cid_codigo = result.Cidade.cid_codigo; // Controle para não spammar consulta.
                });
                $scope.tmp_cep = cep;
            }
        };
        $scope.resolveCaptcha = true;

        /*
            Recaptcha
            */
        $scope.response = null;
        $scope.widgetId = null;
        $scope.recaptcha = {
            key: '6Le2PxkTAAAAABJWPWIkLPa9QJ-J40XaiZkANGTC'//chave do cliente de segurança
        };
        $scope.setResponse = function (response) {
            $scope.responserecaptcha = response;
        };
        $scope.setWidgetId = function (widgetId) {
            $scope.widgetId = widgetId;
        };
        $scope.cbExpiration = function() {
            vcRecaptchaService.reload($scope.widgetId);
            $scope.responserecaptcha = null;
        };

    }]);

    app.config(['flowFactoryProvider',    function(flowFactoryProvider) {
        flowFactoryProvider.defaults = {
            //dynamic target:'/imobiliaria-layout/uploadImg',
            permanentErrors: [404, 500, 501],
            testChunks: false,
            simultaneousUploads: 1,
        };
        function readablizeBytes(bytes) {
            var s = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
            var e = Math.floor(Math.log(bytes) / Math.log(1024));
            return (bytes / Math.pow(1024, e)).toFixed(2) + " " + s[e];
        }


        function secondsToStr (temp) {
            function numberEnding (number) {
                return (number > 1) ? 's' : '';
            }
            var years = Math.floor(temp / 31536000);
            if (years) {
                return years + ' year' + numberEnding(years);
            }
            var days = Math.floor((temp %= 31536000) / 86400);
            if (days) {
                return days + ' day' + numberEnding(days);
            }
            var hours = Math.floor((temp %= 86400) / 3600);
            if (hours) {
                return hours + ' hour' + numberEnding(hours);
            }
            var minutes = Math.floor((temp %= 3600) / 60);
            if (minutes) {
                return minutes + ' minute' + numberEnding(minutes);
            }
            var seconds = temp % 60;
            return seconds + ' second' + numberEnding(seconds);
        }

        flowFactoryProvider.on('fileProgress', function(file){
            // Handle progress for both the file and the overall upload
            var $self = $('.flow-file-'+file.uniqueIdentifier);
            $self.find('.progress-bar').css({width:Math.floor(file.progress()*100) + '%'});
            $self.find('.flow-file-porcentagem').text(Math.floor(file.progress()*100) + '%');
            $self.find('.flow-file-pause').show();
            $self.find('.flow-file-time').text('Tempo:' + readablizeBytes(file.averageSpeed) + '/s '
                + secondsToStr(file.timeRemaining()) + '');
            $self.find('.flow-file-download').attr('href', '/validacao/download/' + file.uniqueIdentifier).hide();

            $self.find('.flow-file-pause').on('click', function () {
                file.pause();
                $self.find('.flow-file-pause').hide();
                $self.find('.flow-file-resume').show();
            });

            $self.find('.flow-file-resume').on('click', function () {
                file.resume();
                $self.find('.flow-file-pause').show();
                $self.find('.flow-file-resume').hide();
            });

            $self.find('.flow-file-cancel').on('click', function () {
                file.cancel();
                $self.remove();
            });

        });


        flowFactoryProvider.on('fileError', function(file, message){
            // Reflect that the file upload has resulted in error
            var $self = $('.flow-file-'+file.uniqueIdentifier);
            $self.find('.flow-file-complete span').text('Erro: '+message+'');
            $self.find('.flow-file-resume').show();
        });

    }]);

});

